import { createElement, type SVGProps } from 'react';
import { getIcon, type IconName } from './registry';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'children'> {
  name: IconName;
  /** Pixel size or any CSS length. Defaults to 1em so icons follow the surrounding text size. */
  size?: number | string;
  /** Accessible label. Omit for decorative icons (they are hidden from assistive tech). */
  label?: string;
}

export function Icon({ name, size = '1em', label, ...rest }: IconProps) {
  const nodes = getIcon(name);
  if (!nodes) {
    console.warn(`[@hobbytools/icons] Unknown icon "${name}"`);
    return null;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    >
      {nodes.map(([tag, props], i) => createElement(tag, { key: i, ...props }))}
    </svg>
  );
}
